import React from "react";

const RightSide = ({ people }) => {
  return (
    <div
      className="
        right mt-4 pb-4 
        lg:pb-0 lg:mt-0 
        lg:w-1/2 
        flex justify-center 
        [@media(min-width:1800px)]:justify-end
      "
    >
      <img
        src={people}
        alt="peoples image"
        className="w-full max-w-[600px] xl:max-w-[700px] [@media(min-width:1800px)]:max-w-[800px] h-auto object-contain"
      />
    </div>
  );
};

export default RightSide;
